<div class="popup" *ngIf="showPopup">
  <div class="overlay"></div>
  <div class="popup-content">
    <form [formGroup]="form">
      <!-- Old Password -->
      <div class="form-group">
        <label for="">Palavra-Passe Atual</label>
        <div class="input-group">
          <input [type]="showOldPassword ? 'text' : 'password'" formControlName="oldPassword" class="form-control">
          <span (click)="toggleOldPasswordVisibility()" class="input-group-text">
            <i [ngClass]="showOldPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
          </span>
        </div>
        <div *ngIf="oldPassword.touched && oldPassword.invalid" class="alert alert-danger">
          <div *ngIf="oldPassword.errors.required">Palavra-passe atual é necessária.</div>
        </div>
      </div>

      <!-- New Password -->
      <div class="form-group">
        <label for="">Nova Palavra-Passe</label>
        <div class="input-group">
          <input [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword" class="form-control">
          <span (click)="toggleNewPasswordVisibility()" class="input-group-text">
            <i [ngClass]="showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
          </span>
        </div>
        <div *ngIf="newPassword.touched && newPassword.invalid" class="alert alert-danger">
          <div *ngIf="newPassword.errors.required">Nova palavra-passe é necessária.</div>
        </div>
      </div>

      <!-- Confirm Password -->
      <div class="form-group">
        <label for="">Confirmar Nova Palavra-Passe</label>
        <div class="input-group">
          <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword" class="form-control">
          <span (click)="toggleConfirmPasswordVisibility()" class="input-group-text">
            <i [ngClass]="showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
          </span>
        </div>
        <div *ngIf="confirmPassword.touched && confirmPassword.invalid" class="alert alert-danger">
          <div *ngIf="confirmPassword.errors.required">Confirmação da nova palavra-passe.</div>
        </div>
      </div>

      <button class="btn btn-primary" (click)="updatePassword()" [disabled]="!form.valid">
        Mudar Palavra-Passe
      </button>
    </form>
  </div>
</div>


<swal #confirmChangePasswordSwal title="Palavra-Passe Alterada com Sucesso" text="" icon="success" [showCancelButton]="false"></swal>
<swal #errorAtualPasswordSwal  title="Palavra-Passe Atual Incorreta" text="Por favor, tente novamente."  icon="error" [showCancelButton]="false"></swal>
<swal #errorNewPasswordSwal title="Confirmação da Nova Palavra-Passe Não Coincide" text="Por favor, tente novamente." icon="error" [showCancelButton]="false"></swal>
